import { render } from "./PostsTableView.vue?vue&type=template&id=7ba5fa3b&scoped=true"
import script from "./PostsTableView.vue?vue&type=script&lang=js"
export * from "./PostsTableView.vue?vue&type=script&lang=js"

import "../../assets/widget.css?vue&type=style&index=0&id=7ba5fa3b&scoped=true&lang=css&external"
import "@/assets/table.css?vue&type=style&index=1&id=7ba5fa3b&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba5fa3b"]])

export default __exports__